import { useEffect, useRef } from "react";
import styles from "./snake.module.scss";

const SnakeGames = () => {
	const canvasRef = useRef(null);
	const btnUp = useRef(null);
	const btnDown = useRef(null);
	const btnLeft = useRef(null);
	const btnRight = useRef(null);
	const btnRestart = useRef(null);

	useEffect(() => {
		// Настройка холста
		const canvas = canvasRef.current;

		if (!canvas) return;

		const ctx = canvas.getContext("2d");

		// Размер ячейки и скорость игры
		const box = 22;
		const speed = 200;

		// Размеры игрового поля
		const fieldWidth = 17;
		const fieldHeight = 17;

		// Инициализация переменных
		let snake, food, score, d, game;

		// Функция инициализации игры
		function init() {
			// Змейка
			snake = [];
			snake[0] = { x: 10 * box, y: 10 * box };

			// Еда
			food = { x: Math.floor(Math.random() * fieldWidth + 1) * box, y: Math.floor(Math.random() * fieldHeight + 1) * box };

			// Счет
			score = 0;

			// Направление
			d = undefined;
		}

		function createFood() {
			let newFood;
			do {
				newFood = {
					x: Math.floor(Math.random() * fieldWidth + 1) * box,
					y: Math.floor(Math.random() * fieldHeight + 1) * box,
				};
			} while (snake.some((segment) => segment.x === newFood.x && segment.y === newFood.y));

			return newFood;
		}

		// Инициализация игры
		init();

		document.addEventListener("keydown", direction);

		let touchStartX = 0;
		let touchStartY = 0;
		let touchEndX = 0;
		let touchEndY = 0;

		document.addEventListener(
			"touchstart",
			function (event) {
				touchStartX = event.changedTouches[0].screenX;
				touchStartY = event.changedTouches[0].screenY;
			},
			false
		);

		document.addEventListener(
			"touchend",
			function (event) {
				touchEndX = event.changedTouches[0].screenX;
				touchEndY = event.changedTouches[0].screenY;
				handleSwipe();
			},
			false
		);

		function handleSwipe() {
			const deltaX = touchEndX - touchStartX;
			const deltaY = touchEndY - touchStartY;

			// Определяем, был ли свайп достаточно длинным
			if (Math.abs(deltaX) > 30 || Math.abs(deltaY) > 30) {
				if (Math.abs(deltaX) > Math.abs(deltaY)) {
					// Горизонтальный свайп
					if (deltaX > 0 && d !== "LEFT") {
						d = "RIGHT";
					} else if (deltaX < 0 && d !== "RIGHT") {
						d = "LEFT";
					}
				} else {
					// Вертикальный свайп
					if (deltaY > 0 && d !== "UP") {
						d = "DOWN";
					} else if (deltaY < 0 && d !== "DOWN") {
						d = "UP";
					}
				}
			}
		}

		function direction(event) {
			if (event.keyCode == 37 && d != "RIGHT") d = "LEFT";
			else if (event.keyCode == 38 && d != "DOWN") d = "UP";
			else if (event.keyCode == 39 && d != "LEFT") d = "RIGHT";
			else if (event.keyCode == 40 && d != "UP") d = "DOWN";
			else if (event.keyCode == 82) restartGame();
		}

		function collision(head, array) {
			for (let i = 0; i < array.length; i++) {
				if (head.x == array[i].x && head.y == array[i].y) return true;
			}
			return false;
		}

		function drawBorder() {
			ctx.strokeStyle = "#6f618d";
			ctx.lineWidth = 3;
			ctx.strokeRect(box, box, fieldWidth * box, fieldHeight * box);
		}

		function draw() {
			ctx.clearRect(0, 0, canvas.width, canvas.height);

			drawBorder();

			for (let i = 0; i < snake.length; i++) {
				ctx.fillStyle = i == 0 ? "green" : "white";
				ctx.fillRect(snake[i].x, snake[i].y, box, box);

				ctx.strokeStyle = "black";
				ctx.strokeRect(snake[i].x, snake[i].y, box, box);
			}

			ctx.fillStyle = "red";
			ctx.fillRect(food.x, food.y, box, box);

			let snakeX = snake[0].x;
			let snakeY = snake[0].y;

			if (d == "LEFT") snakeX -= box;
			if (d == "UP") snakeY -= box;
			if (d == "RIGHT") snakeX += box;
			if (d == "DOWN") snakeY += box;

			// Проход через стены
			if (snakeX < box) snakeX = fieldWidth * box;
			if (snakeX > fieldWidth * box) snakeX = box;
			if (snakeY < box) snakeY = fieldHeight * box;
			if (snakeY > fieldHeight * box) snakeY = box;

			if (snakeX == food.x && snakeY == food.y) {
				score++;
				food = createFood();
			} else {
				snake.pop();
			}

			let newHead = { x: snakeX, y: snakeY };

			if (collision(newHead, snake)) {
				clearInterval(game);
				gameOver();
			}

			snake.unshift(newHead);
		}

		function gameOver() {
			ctx.fillStyle = "white";
			ctx.font = "65px Changa one";
			ctx.fillText("GAME OVER", canvas.width / 2 - 190, canvas.height / 2);
			ctx.font = "30px Changa one";
			ctx.fillText("Press R to restart", canvas.width / 2 - 100, canvas.height / 2 + 50);
		}

		function restartGame() {
			clearInterval(game);
			init();
			game = setInterval(draw, speed);
		}

		// Запуск игры
		game = setInterval(draw, speed);

		function handleUpClick() {
			if (d !== "DOWN") d = "UP";
		}

		function handleLeftClick() {
			if (d !== "RIGHT") d = "LEFT";
		}

		function handleRightClick() {
			if (d !== "LEFT") d = "RIGHT";
		}

		function handleDownClick() {
			if (d !== "UP") d = "DOWN";
		}

		// Добавление обработчиков событий

		btnUp.current.addEventListener("click", handleUpClick);
		btnLeft.current.addEventListener("click", handleLeftClick);
		btnRight.current.addEventListener("click", handleRightClick);
		btnDown.current.addEventListener("click", handleDownClick);
		btnRestart.current.addEventListener("click", restartGame);

		return () => {
			clearInterval(game);
			document.removeEventListener("keydown", direction);
		};
	}, [canvasRef]);

	return (
		<>
			<canvas className={`${styles.game}`} ref={canvasRef} id="gameCanvas" width="420" height="420" touch-action="none" />
			<div className={styles["touch-controls"]}>
				<button ref={btnLeft}>◀️</button>
				<button ref={btnUp}>🔼</button>
				<button ref={btnDown}>🔽</button>
				<button ref={btnRight}>▶️</button>
				<button ref={btnRestart}>🔄️</button>
			</div>
		</>
	);
};

export default SnakeGames;
